import { createFileRoute } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { useState } from 'react'
import { AccountShell } from '../../components/account/AccountShell'
import { WorkspaceCard } from '../../components/account/WorkspaceCard'
import { CreateWorkspaceModal } from '../../components/CreateWorkspaceModal'
import { Button, Text } from '../../components/ui'
import { useWorkspaces } from '../../hooks/useWorkspaces'

export const Route = createFileRoute('/workspaces/')({
  component: WorkspacesPage,
})

function WorkspacesPage() {
  const [createOpen, setCreateOpen] = useState(false)

  const { data: workspacesResult, isLoading } = useWorkspaces()

  const workspaces = workspacesResult?.success ? workspacesResult.data : []
  const needsWorkspace = !isLoading && workspaces.length === 0

  return (
    <AccountShell>
      <div className="mx-auto w-full max-w-5xl">
        <div className="mb-6 flex flex-col gap-4 sm:mb-8 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <Text variant="h2" className="mb-1 text-2xl sm:text-3xl">
              Workspaces
            </Text>
            <Text variant="body-sm" className="text-foreground/60">
              Manage the teams and products you belong to.
            </Text>
          </div>

          <Button
            type="button"
            fullWidth
            className="sm:w-auto"
            leftIcon={<Plus className="h-4 w-4" />}
            onClick={() => setCreateOpen(true)}
          >
            New workspace
          </Button>
        </div>

        {isLoading ? (
          <div className="grid gap-4 sm:grid-cols-2">
            {Array.from({ length: 2 }).map((_, index) => (
              <div
                key={index}
                className="h-56 animate-pulse rounded-3xl border border-foreground/10 bg-stone/60"
              />
            ))}
          </div>
        ) : workspaces.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-foreground/15 bg-stone/40 px-4 py-12 text-center sm:rounded-3xl sm:px-6 sm:py-16">
            <Text variant="h2" className="mb-2 text-xl">
              No workspaces yet
            </Text>
            <Text variant="body-sm" className="mx-auto mb-6 max-w-sm text-foreground/60">
              Create your first workspace to start using SonderSoft Knowledge and Support.
            </Text>
            <Button type="button" onClick={() => setCreateOpen(true)}>
              Create workspace
            </Button>
          </div>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2">
            {workspaces.map((workspace) => (
              <WorkspaceCard key={workspace.id} workspace={workspace} />
            ))}
          </div>
        )}
      </div>

      <CreateWorkspaceModal
        open={needsWorkspace || createOpen}
        onClose={needsWorkspace ? undefined : () => setCreateOpen(false)}
      />
    </AccountShell>
  )
}
